import {Component, OnInit}        from '@angular/core';
declare var $: any;
import {PermisoService} from '../permiso/permiso.service';
import {ActivatedRoute, Router} from '@angular/router';
import {TipoBateriaService} from './tipoBateria.service';
import {TipoBateria} from './tipoBateria';
import {LoginService} from '../login/login.service';
import 'rxjs/Rx';

import myGlobals = require('../config');

@Component({
    selector: 'tipoBateria',
    template: require('../../app/tipoBateria/tipoBateria.component.html'),
    styles: [require('../../app/tipoBateria/tipoBateria.component.css')]
})
export class TipoBateriaComponent implements OnInit {
    tipoBateria: TipoBateria;
    idSeleccionado;
    active: any;
    active2: any;
    deshabilitar: boolean;
    permisos: any;

    constructor(private tipoBateriaService: TipoBateriaService,
                private permisoService: PermisoService,
                private loginService: LoginService,
                private router: Router) {
    }

    ngOnInit() {
        window.scrollTo(0, 0);

        //Perdir permisos
        this.permisos = new Map();
        this.permisoService.getPermiso("tipoBateria").subscribe(permisos => {
            for (let permiso of permisos.tipoPermiso) {
                this.permisos.set(permiso.descripcion, true);
            }
            //Si no tiene permiso para ver redirijo
            if (!this.permisos.get("read"))
                this.router.navigate(['/home']);
        });

        //Inicializar tabla
        $("#grid-data").bootgrid({
            ajax: true,
            url: myGlobals.default.BASE_URL + "/tipoBateria/tipoBateriaTable",
            selection: true,
            multiSelect: false,
            rowSelect: true,
            formatters: {
                "estado": function (column, row) {
                    return row.estado == true ? "Activo" :  "<span class=\"label label-danger\">Inactivo</span>"
                }
            },
            ajaxSettings: {
                headers: {
                    "Authorization": this.loginService.getToken()
                },
                method: "GET"
            }
        })
        //Cerrar alert
        $("#alertSeleccion").hide();
        //Inicializar banderas para resetear forms
        this.active = true;
        //Inicializar
        this.tipoBateria = new TipoBateria();
        //Inicializar bandera deshabilitar
        this.deshabilitar = false;
    }

    ngOnDestroy() {
    }

    agregar() {
        //Inicializo variables
        this.tipoBateria = new TipoBateria();
        this.deshabilitar = false;
        $("#modalTipoBateria").modal("show");
        //Reseteo form para eliminar errores
        this.active = false;
        setTimeout(() => this.active = true, 0);
    }

    modificar() {
        //Obtener id seleccionado
        this.idSeleccionado = $("#grid-data").bootgrid("getSelectedRows")[0];
        //Si no hay nada seleccionado mostrar alert
        if (this.idSeleccionado == undefined) {
            $("#alertSeleccion").show();
        }
        else {
            if (this.idSeleccionado != "0") {
                //Cerrar alert
                $("#alertSeleccion").hide();
                //Busco tipoBateria
                this.tipoBateriaService
                    .getTipoBateria(this.idSeleccionado)
                    .subscribe(tipoBateria => {
                        this.tipoBateria = tipoBateria;
                    });
                this.deshabilitar = false;
                $("#modalTipoBateria").modal("show");
            }
        }
    }

    eliminar() {
        //Obtener id seleccionado
        this.idSeleccionado = $("#grid-data").bootgrid("getSelectedRows")[0];
        //Si no hay nada seleccionado mostrar alert
        if (this.idSeleccionado == undefined) {
            $("#alertSeleccion").show();
        }
        else {
            if (this.idSeleccionado != "0") {
                //Cerrar alert
                $("#alertSeleccion").hide();
                //Busco tipoBateria
                this.tipoBateriaService
                    .getTipoBateria(this.idSeleccionado)
                    .subscribe(tipoBateria => {
                        this.tipoBateriaService.delete(tipoBateria).subscribe(() => $("#grid-data").bootgrid("reload"));

                    });
            }
        }
    }

    ver() {
        //Obtener id seleccionado
        this.idSeleccionado = $("#grid-data").bootgrid("getSelectedRows")[0];
        //Si no hay nada seleccionado mostrar alert
        if (this.idSeleccionado == undefined) {
            $("#alertSeleccion").show();
        }
        else {
            if (this.idSeleccionado != "0") {
                //Cerrar alert
                $("#alertSeleccion").hide();
                //Busco tipoBateria
                this.tipoBateriaService
                    .getTipoBateria(this.idSeleccionado)
                    .subscribe(tipoBateria => {
                        this.tipoBateria = tipoBateria;
                    });
                //Seteo bandera para deshabilitar
                this.deshabilitar = true;
                $("#modalTipoBateria").modal("show");

            }
        }
    }

    save() {

        this.tipoBateriaService
            .save(this.tipoBateria)
            .subscribe((tipoBateria) => {
                this.tipoBateria = tipoBateria;
                //Inicializo variables
                this.tipoBateria = new TipoBateria();
                console.log(this.tipoBateria);
                //Ocultar modal
                $("#modalTipoBateria").modal("hide");
                //Reseteo formtipoBateria para eliminar errores
                this.active = false;
                setTimeout(() => this.active = true, 0);
                //Recargo tabla
                $("#grid-data").bootgrid("reload");
            })
    }

    hideAlert() {
        $("#alertSeleccion").hide();
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/tipoBateria/tipoBateria.component.ts